import './entry_shared.js'

import mapLoader from '../map_loader.js'
mapLoader.loadMap()
